var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading === true)?_c('div',{class:{ active: _vm.isLoading },attrs:{"id":"loading"}},[_c('RotateSquare5',{attrs:{"size":"100px","color":"#1979cc"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }